export default{
    created () {
        this.$store.dispatch("getUsuarioHTTP");
    },
    computed: {
        credential() {
            return this.$store.getters.allCredenciales
        }
    },
    methods: {
        hasTheCredential(credential) {
            const regex = new RegExp(credential, "i");
            const test = this.credential.some(s=>regex.test(s))
            return test;
        }
    },
}